import { generateDatesForDropdown } from '../../utils/dropdown';

export const FINISH_DATES = generateDatesForDropdown();
